import React, { useState, useCallback, useEffect, useRef } from "react";
import { Col, Label, Row, TabPane, Input, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const TabConfig = ({ user_id, lojista, setLojista }) => {
  const [loading, setLoading] = useState(false);

  const toggleConversao = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await apiClient.put(`/lojista/toggle-auto-convert/${user_id}`);

    if (response.sucesso) {
      toast.success(response.mensagem);
      lojista.auto_converter = !lojista.auto_converter;
      setLojista(lojista);
    } else {
      toast.error(response.mensagem);
      console.log(response);
    }

    setLoading(false);
  };

  return (
    <TabPane tabId="4">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "20px",
          }}
        >
          <Spinner height={100} width={100} />
        </div>
      ) : (
        <>
          <Row>
            <Col lg={4}>
              <div className="form-check form-switch mb-3">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  defaultChecked={lojista.auto_converter}
                  onChange={toggleConversao}
                />
                <Label className="form-check-label" htmlFor="SwitchCheck1">
                  Auto Converter Ordens de vendas para R$?
                </Label>
              </div>
            </Col>
          </Row>
        </>
      )}
    </TabPane>
  );
};

export default TabConfig;
